<!-- Accessible date/time selector form control -->
<div class="wrap" role="region" aria-label="Date and time selection">
	<!-- Date selection section -->
	<section class="date-section" aria-labelledby="date-heading">
		<h3 id="date-heading" class="section-heading visually-hidden">
			{{ 'slots_selector.date' | translate }}
		</h3>

		<div class="row-first">
			<div class="slot-col">
				<div
					class="date-listbox"
					role="listbox"
					aria-label="Available dates"
					[attr.aria-activedescendant]="getSelectedDateId()"
					(keydown)="handleDateKeyNavigation($event)"
					tabindex="0"
				>
					<!-- Date options -->
					<ng-container *ngFor="let date of dates; let i = index">
						<button
							*ngIf="maxDates > i"
							class="slot-square date-slot"
							[class.selected]="TimeUtils.isSameDate(date, slot) || (i === 0 && !slot)"
							[attr.id]="'date-' + i"
							[attr.aria-label]="getDateAriaLabel(date, i)"
							[attr.aria-selected]="TimeUtils.isSameDate(date, slot) || (i === 0 && !slot) ? 'true' : 'false'"
							role="option"
							tabindex="0"
							(click)="setDate(date)"
						>
							{{ slotToDateText(date) }}
						</button>
					</ng-container>
					<!-- Show more dates button -->
					<button
						*ngIf="maxDates < dates.length"
						class="slot-square more-button"
						(click)="showMoreDates()"
						(keydown.enter)="showMoreDates()"
						(keydown.space)="showMoreDates()"
						aria-label="Show more available dates"
						tabindex="0"
					>
						{{ 'checkout_modal.more' | translate }}
					</button>
				</div>
			</div>
		</div>
	</section>

	<!-- Time selection section -->
	<section class="time-section" aria-labelledby="time-heading">
		<h3 id="time-heading" class="section-heading visually-hidden">
			{{ 'slots_selector.time' | translate }}
		</h3>

		<div class="row-second">
			<div class="slot-col" #timeCol>
				<div
					class="time-listbox"
					role="listbox"
					aria-label="Available times"
					[attr.aria-activedescendant]="getSelectedTimeId()"
					(keydown)="handleTimeKeyNavigation($event)"
					tabindex="0"
				>
					<ng-container *ngFor="let time of timesForDate(slot); let i = index">
						<!-- Time options -->
						<button
							*ngIf="maxSlots > i"
							class="slot-square time-slot"
							[class.smaller]="!time"
							[class.selected]="slot === time"
							[attr.id]="'time-' + i"
							[attr.aria-label]="getTimeAriaLabel(time, i)"
							[attr.aria-selected]="slot === time ? 'true' : 'false'"
							[attr.disabled]="!time ? 'true' : null"
							role="option"
							tabindex="0"
							(click)="setTime(time)"
							(keydown.enter)="time ? setTime(time) : null"
							(keydown.space)="time ? setTime(time) : null"
						>
							{{ slotToTimeText(time) }}
						</button>
					</ng-container>
					<!-- Show more times button -->
					<button
						*ngIf="maxSlots < timesForDate(slot).length"
						class="slot-square more-button"
						(click)="showMoreTimes()"
						(keydown.enter)="showMoreTimes()"
						(keydown.space)="showMoreTimes()"
						aria-label="Show more available times"
						tabindex="0"
					>
						{{ 'checkout_modal.more' | translate }}
					</button>
				</div>
			</div>
		</div>
	</section>

	<!-- Screen reader announcements -->
	<div class="visually-hidden" aria-live="polite" id="selection-announcer"></div>

	<!-- Instructions for keyboard users -->
	<div class="visually-hidden" id="keyboard-instructions">
		Use arrow keys to navigate between options. Press Enter or Space to select.
	</div>
</div>
